module.exports = __webpack_public_path__ + "static/media/scanner-touchscreen.a3a7cc0e.svg";